import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { Tab, Tabs } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { IsSentEnum } from '../models/isSent.enum';

interface GroupMessageEmailTabsProps {
  initialValue: number | undefined;
  callback: (activeTab: number, isSent: boolean | undefined, archivedMessages: boolean | undefined) => void;
}

type InvoiceTab = {
  id: number;
  label: string;
};

const tabs: InvoiceTab[] = [
  {
    id: 0,
    label: t('groupMessage:overview.tabs.all'),
  },
  {
    id: 1,
    label: t('groupMessage:overview.tabs.sent'),
  },
  {
    id: 2,
    label: t('groupMessage:overview.tabs.notSent'),
  },
  {
    id: 3,
    label: t('groupMessage:overview.tabs.archived'),
  },
];

export const GroupMessageEmailTabs = (props: GroupMessageEmailTabsProps) => {
  const { initialValue, callback } = props;
  const [activeTab, setActiveTab] = useState<number>(initialValue || 0);
  const [, setIsSent] = useState<boolean | undefined>();

  const handleTab = (tabIndex: number) => {
    setActiveTab(tabIndex);
    let sent;
    let archivedMessages: boolean | undefined;
    switch (tabIndex) {
      case IsSentEnum.All:
        sent = undefined;
        archivedMessages = undefined;
        break;
      case IsSentEnum.Sent:
        sent = true;
        archivedMessages = undefined;
        break;
      case IsSentEnum.NotSent:
        sent = false;
        archivedMessages = undefined;
        break;
      case IsSentEnum.Archived:
        sent = undefined;
        archivedMessages = true;
        break;
      default:
        sent = undefined;
    }
    setIsSent(sent);
    return { sent, archivedMessages };
  };

  const onTabSelect = (event: React.SyntheticEvent, tabIndex: number) => {
    const tab = handleTab(tabIndex);
    callback(tabIndex, tab.sent, tab.archivedMessages);
  };

  useEffect(() => {
    if (initialValue !== undefined) {
      handleTab(initialValue);
    }
  }, [initialValue]);

  const leftTabs = tabs.filter((tab) => tab.id !== 3);
  const archivedTab = tabs.find((tab) => tab.id === 3);

  return (
    <Tabs
      value={activeTab}
      textColor='primary'
      onChange={onTabSelect}
      sx={{
        '& button': {
          textTransform: 'none',
        },
      }}
    >
      {leftTabs.map((tab: InvoiceTab) => (
        <Tab label={tab.label} key={tab.id} />
      ))}
      {archivedTab && (
        <Tab
          sx={{
            marginLeft: 'auto',
            minHeight: 'auto',
          }}
          label={archivedTab.label}
          icon={<Delete sx={{ mb: '2px' }} fontSize='small' />}
          iconPosition='start'
        />
      )}
    </Tabs>
  );
};
